import React, { useEffect, useRef } from 'react';
import styles from './Mensagens.module.css';
import Botao from '../../components/Botao';
import {
  mdiAccountPlus,
  mdiArrowLeft,
  mdiArrowRight,
  mdiChatProcessing,
  mdiCheckCircle,
  mdiClose,
  mdiHeadset,
  mdiLoading,
  mdiMessage,
  mdiRobot,
  mdiTagPlus,
  mdiThumbDown,
  mdiThumbUp,
  mdiPhone,
  mdiFaceAgent,
  mdiOpenInNew,
  mdiPen,
  mdiContentSave,
  mdiCancel,
  mdiPlus,
  mdiEyeCircleOutline,
} from '@mdi/js';
import Icon from '../../components/Icon'
import Badge from '../../components/layout/Badge';
import HBox from '../../components/layout/HBox';
import { ChatMensagemDto } from '@tera/shared/src/dto/ChatMensagemDto';
import ChatDto, { ChatDtoEstado } from '@tera/shared/src/dto/ChatDto';
import { chatKey } from './chatList';
import TextoTelefone from '../../components/layout/TextoTelefone';
import IconeCanal from '../../components/layout/IconeCanal';
import Footer from './footer/Footer';
import VBox from '../../components/layout/VBox';
import Mensagem from './Mensagem';
import Modal from '../../components/layout/Modal';
import CampoSeletor, {
  CampoSeletorOption,
  CampoSeletorOptions,
} from '../../components/Formulario/CampoSeletor';
import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BadgeMarcadores } from './BadgeMarcadores';
import { useAuth } from '@/lib/useAuth';
import Marcadores from '@/components/layout/Marcadores';
import { FormNovoCliente } from './FormNovoCliente';
import stylesFooter from './footer/Footer.module.css';
import FooterBloqueado from './footer/FooterBloqueado';
import { id } from 'date-fns/locale';
import Grid, { GridItem } from '@/components/layout/Grid';
import CampoTexto from '@/components/Formulario/CampoTexto';
import CampoMemo from '@/components/Formulario/CampoMemo';
import CampoMemoMencao from '@/components/Formulario/CampoMemoMencao';
import AlertBox from '@/components/layout/AlertBox';
import { TicketPrioridade } from '@tera/shared/src/dto/TicketDto';
import { queryClient } from '@/queryClient';
import { format, formatDate } from 'date-fns';
import { Editavel } from '@/components/Editavel';

// const dt = Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
type Props = {
  chat: ChatDto;
  value: ChatMensagemDto[];
  onChatEstadoChange: (estado: ChatDtoEstado, solucionado?: boolean) => void;
  onChatAddTag: (chatId: number, tagId: number) => void;
  onSend: (mensagem: string, anexos: File[]) => void;
  isSending: boolean;
  onSendAudio: (audio: Blob) => void;
  onLoadMore: (cursor: string) => void;
  isLoading: boolean;
  hasMorePages: boolean;
  onReloadChats: () => void;
  onSelectedKbSection: (selection: any) => void;
  onGoBack: () => void;
  onAccept: () => void;
  canAccept: boolean;
  onBlockContact?: () => void;
  onAudioPlaying?: (isPlaying: boolean) => void;
  onTyping: (isTyping: boolean) => void;
  canMakeCall: boolean;
  onMakeCall: () => void;
  params: Record<string, any>;
};
const Mensagens = ({
  chat,
  value,
  onChatEstadoChange,
  onChatAddTag,
  onSend,
  isSending,
  onSendAudio,
  onLoadMore,
  isLoading,
  hasMorePages,
  onReloadChats,
  onSelectedKbSection,
  onGoBack,
  onAccept,
  canAccept,
  onBlockContact,
  onAudioPlaying,
  onTyping,
  canMakeCall,
  onMakeCall,
  params,
}: Props) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showTrocarAtendente, setShowTrocarAtendente] = React.useState(false);
  const [atendenteSelecionado, setAtendenteSelecionado] =
    React.useState<any>(null);
  const [departamentoSelecionado, setDepartamentoSelecionado] =
    React.useState<any>(null);
  const [motivo, setMotivo] = React.useState(''); // Novo estado para o motivo

  const containerScrollRef = useRef<any>(null);

  const fetching = useRef<boolean>(false);
  useEffect(() => {
    const handleScroll = async (e: any) => {
      const { scrollHeight, scrollTop, clientHeight } = e.target;

      if (
        !fetching.current &&
        !isLoading &&
        scrollHeight + scrollTop <= clientHeight * 1.2 &&
        hasMorePages
      ) {
        fetching.current = true;
        onLoadMore(value?.[value.length - 1]?.data_criacao!);
      }
    };

    const csr = containerScrollRef.current;
    csr?.addEventListener('scroll', handleScroll);
    return () => {
      csr?.removeEventListener('scroll', handleScroll);
    };
  }, [hasMorePages, value, chat, onLoadMore, isLoading]);

  useEffect(() => {
    if (!isLoading) fetching.current = false;
  }, [isLoading]);

  const chatChanged = useRef(false);
  useEffect(() => {
    console.log('chat updated', chat, containerScrollRef.current);
    if (chat != null) {
      chatChanged.current = false;
      containerScrollRef.current.scrollTo({
        top: 0,
      });
    }
  }, [chat]);

  useEffect(() => {
    setChangingEstado(false);
  }, [chat.estado]);

  const handleCloseModal = () => {
    setShowTrocarAtendente(false);
  };

  const handleOpenModal = () => {
    setShowTrocarAtendente(true);
    setAtendenteSelecionado(null);

    setAtendSelId(null);
    setGrupoDoUsuarioSelId(null);
    setAtendSearch('');
    setMotivo(''); // Limpar motivo ao abrir modal
  };

  const chgAtendenteMutator = useMutation(
    (data: { type: string, id: number, grupo_id?: number | null, motivo: string }) => {
      return axios.post(`/api/chat/${chat.id}/atendente`, data);
    },
    {
      onSuccess: data => {
        console.log('atendente changed', data);
        setShowTrocarAtendente(false);
        toast('Atendente alterado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: (error: any) => {
        console.error(error);
        toast(error?.response?.data?.msg || 'Erro ao alterar atendente', {
          toastId: 'error',
          position: 'top-center',
          type: 'error',
          autoClose: 5000,
        });
      },
    },
  );

  const handleConfirmModal = () => {
    const data = atendenteSelecionado ? {
      type: 'usuario', id: atendenteSelecionado, grupo_id: grupoDoUsuarioSelId ? +grupoDoUsuarioSelId : null, motivo
    } : {
      type: 'grupo', id: departamentoSelecionado, motivo
    }

    chgAtendenteMutator.mutate(data);
  };

  const queryUsuarios = useQuery<any[]>('usuario', async () => {
    const result = await axios.get('/api/usuario/box');
    return result.data?.result;
  });

  const atendentes =
    queryUsuarios?.data
      ?.filter((it: any) => it.id != chat.usuario_responsavel_id)
      ?.reduce(
        (acc: CampoSeletorOption[], it: any) => {
          if (it.grupos) {
            for (const g of it.grupos) {
              if (g.aceita_atendimento === false) continue;
              acc.push(
                ({
                  id: it.id.toString(),
                  label: it.nome,
                  group: g.nome,
                  groupId: g.id.toString(),
                }) as CampoSeletorOption
              )
            }
          }
          return acc
        },
        [],
      )?.sort((a: CampoSeletorOption, b: CampoSeletorOption) => `${a.group}--${a.label}`.localeCompare(`${b.group}--${b.label}`)) ?? [];

  const queryGrupos = useQuery<any[]>('usuario_grupo', async () => {
    const result = await axios.get('/api/usuario_grupo/box');
    return result.data?.result;
  });

  const [atendSelId, setAtendSelId] = React.useState<string | null>(null);
  const [grupoSelId, setGrupoSelId] = React.useState<string | null>(null);
  const [grupoDoUsuarioSelId, setGrupoDoUsuarioSelId] = React.useState<string | null>(null);
  const [atendSearch, setAtendSearch] = React.useState<string>('');

  const [showAddTag, setShowAddTag] = React.useState(false);
  const [selectedTagId, setSelectedTagId] = React.useState<any>(null);

  const [showAddClient, setShowAddClient] = React.useState(false);
  const [newClient, setNewClient] = React.useState<any>(null);

  const qTags = useQuery('tags', async () => {
    const result = await axios.get('/api/marcador/box');
    return result.data?.result;
  });

  const optionsTags =
    qTags.data
      ?.filter((it: any) => ['qualquer', 'cliente'].includes(it.local))
      ?.map((it: any) => ({
        id: it.id.toString(),
        label: it.nome,
      })) ?? [];

  const addTagMutator = useMutation(
    (tagId: string) => {
      return axios.post(`/api/cliente/${chat.cliente?.id}/marcador/${tagId}`);
    },
    {
      onSuccess: () => {
        setShowAddTag(false);
        onReloadChats();
        toast('Marcador adicionado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: error => {
        console.error(error);
        toast('Erro ao adicionar marcador', {
          toastId: 'error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
    },
  );

  const addClientMutator = useMutation(
    async () => {
      return axios.post('/api/chat/cliente', newClient);
    },
    {
      onSuccess: () => {
        toast('Cliente adicionado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        onReloadChats();
        handleCloseModalNewClient();
      },
      onError: () => {
        toast('Erro ao adicionar cliente', {
          toastId: 'error',
          position: 'top-center',
          type: 'error',
          autoClose: 5000,
        });
      },
    },
  );

  const handleOpenModalNewClient = () => {
    setShowAddClient(true);
    setNewClient({
      nome: chat.nome,
      contato_tipo: chat.canal?.tipo == 'wa360' ? 'whatsapp' : chat.canal?.tipo,
      contato_valor: chat.canal_cliente_id?.toString(),
      metadados: {},
    });
  };

  const handleCloseModalNewClient = () => {
    setShowAddClient(false);
    setNewClient(null);
  };

  const handleSaveNewClient = async () => {
    addClientMutator.mutate();
  };

  const [finalizando, setFinalizando] = React.useState(false);
  const [changingEstado, setChangingEstado] = React.useState<boolean>(false);

  const qTickets = useQuery({
    queryKey: ['tickets/box', chat?.cliente?.id],
    queryFn: async () => {
      if (!chat?.cliente?.id) return [];

      const result = await axios.get('/api/ticket/box', {
        params: {
          cliente_id: chat.cliente.id,
          box: 'abertos',
          take: 5,
        },
      });
      return result.data?.result;
    },
  });


  const [showTickets, setShowTickets] = React.useState(false);
  const [showNewClientTicket, setShowNewClientTicket] = React.useState(false);
  const [novaAtividadeDesc, setNovaAtividadeDesc] = React.useState<string>('');
  const [atividadeEditandoId, setAtividadeEditandoId] = React.useState<number | null>(null);
  const [atividadeDescricaoEdit, setAtividadeDescricaoEdit] = React.useState<string>('');
  const [atividadeEditLoading, setAtividadeEditLoading] = React.useState<boolean>(false);

  const [objTicketActivity, setObjTicketActivity] = React.useState<any>(null);

  const [objNewTicket, setObjNewTicket] = React.useState<Partial<{
    titulo: string;
    descricao: string;
    prioridade: TicketPrioridade;
    atividade_inicial: string;
  }> | null>(null)

  const qNewTicketSuggestion = useQuery({
    queryKey: ['new_ticket_suggestion', chat?.id],
    queryFn: async () => {
      if (!chat?.id) return null;

      const result = await axios.post('/api/chat/new-ticket-suggestion', {
        chat_id: chat.id,
        canal_id: chat.canal?.id,
        canal_cliente_id: chat.canal_cliente_id,
      });
      return result.data?.result;
    },
    enabled: chat?.canal?.id != null && chat?.canal_cliente_id != null && showNewClientTicket,
    refetchOnWindowFocus: false,

    onSuccess: data => {
      console.log('new ticket suggestion', data);

      const { success, titulo, descricao, prioridade, atividade_inicial } = data;

      if (success) {
        setObjNewTicket(prev => ({
          titulo: prev?.titulo || titulo || '',
          descricao: prev?.descricao || descricao || '',
          prioridade: prev?.prioridade || prioridade || 'media',
          atividade_inicial: prev?.atividade_inicial || atividade_inicial || '',
        }));
      }
    },
  });

  const handleCloseNewTicket = () => {
    setShowNewClientTicket(false);
    setObjNewTicket(null);
  }

  const newTicketMutator = useMutation(
    async (data: {
      titulo: string;
      descricao: string;
      prioridade: TicketPrioridade;
      atividade_inicial: string;
      cliente_id: number;
    }) => {
      return axios.post('/api/ticket', data);
    },
    {
      onSuccess: () => {
        toast('Ticket criado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        handleCloseNewTicket();
        queryClient.invalidateQueries(['tickets']);
        queryClient.invalidateQueries(['tickets/box']);
      },
      onError: (error: any) => {
        console.error(error);
        toast(error?.response?.data?.message || 'Erro ao criar ticket', {
          toastId: 'error',
          position: 'top-center',
          type: 'error',
          autoClose: 5000,
        });
      },
    },
  );

  const handleSaveNewTicket = () => {
    newTicketMutator.mutate({
      titulo: objNewTicket?.titulo!,
      descricao: objNewTicket?.descricao!,
      prioridade: objNewTicket?.prioridade!,
      atividade_inicial: objNewTicket?.atividade_inicial!,
      cliente_id: chat?.cliente?.id!,
    })
  }

  const handleSaveTicketActivity = () => {
    adicionarAtividadeMutator.mutate({ ticketId: objTicketActivity?.ticketId!, descricao: objTicketActivity?.descricao! });
  }

  const adicionarAtividadeMutator = useMutation(
    async ({ ticketId, descricao }: { ticketId: number; descricao: string }) => {
      const { data } = await axios.post(`/api/ticket/${ticketId}/atividade`, { descricao }, { withCredentials: true });
      return data;
    },
    {
      onSuccess: () => {
        toast('Atividade adicionada com sucesso', { position: 'top-center', type: 'success' });
        setNovaAtividadeDesc('');
        setObjTicketActivity(null);
        queryClient.invalidateQueries(['tickets', chat?.cliente?.id]);
        queryClient.invalidateQueries(['tickets/box', chat?.cliente?.id]);
      },
      onError: (error: any) => {
        const msg = error?.response?.data?.msg ?? 'Erro ao adicionar atividade';
        toast(msg, { position: 'top-center', type: 'error' });
      }
    }
  );

  const editarAtividadeMutator = useMutation(
    async ({ ticketId, atividadeId, descricao }: { ticketId: number; atividadeId: number; descricao: string }) => {
      const { data } = await axios.put(`/api/ticket/${ticketId}/atividade/${atividadeId}`, { descricao }, { withCredentials: true });
      return data;
    },
    {
      onSuccess: () => {
        toast('Descrição da atividade atualizada', { position: 'top-center', type: 'success' });
        setAtividadeEditandoId(null);
        setAtividadeDescricaoEdit('');
        queryClient.invalidateQueries(['tickets', chat?.cliente?.id]);
        queryClient.invalidateQueries(['tickets/box', chat?.cliente?.id]);
      },
      onError: (error: any) => {
        const msg = error?.response?.data?.msg ?? 'Erro ao atualizar atividade';
        toast(msg, { position: 'top-center', type: 'error' });
      }
    }
  );

  const dentroJanela30Min = (atividade: any) => {
    const dataCriacao = atividade.data_criacao ? new Date(atividade.data_criacao) : new Date(atividade.data_inicio);
    const agora = new Date();
    const diffMin = (agora.getTime() - dataCriacao.getTime()) / (1000 * 60);
    return diffMin <= 30;
  };

  if (!chat) return null;

  return (
    <div className={styles.container}>
      <Modal
        size="md"
        show={showAddClient}
        onClose={handleCloseModalNewClient}
        onCancel={handleCloseModalNewClient}
        onConfirm={handleSaveNewClient}
        title="Dados do contato"
        confirmProps={{
          label: 'Confirmar',
          disabled: addClientMutator.isLoading,
        }}
        cancelProps={{
          disabled: addClientMutator.isLoading,
        }}
      >
        <FormNovoCliente
          enabled={showAddClient}
          value={newClient}
          onChange={setNewClient}
        />
      </Modal>

      <Modal
        size="md"
        show={showTickets}
        onClose={() => setShowTickets(false)}
        onCancel={() => setShowTickets(false)}
        title="Tickets abertos deste contato"
        hideControls
      >
        <VBox gap="16px">
          {qTickets.data != null && qTickets.data.length > 0 && (
            qTickets.data.map((it: any) => {
              // Atividade mais recente
              const atividade = it.atividades && it.atividades.length > 0
                ? it.atividades.reduce((a: any, b: any) => new Date(a.data_inicio) > new Date(b.data_inicio) ? a : b)
                : null;
              return (
                <div key={it.id} style={{ border: '1px solid var(--tc-color-gray-300)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
                  <Grid>
                    <GridItem sm={12} md={5}>
                      <div style={{ color: 'var(--tc-color-gray-700)' }}><b>#{it.id}</b> - {it.titulo}</div>
                      <div style={{ fontSize: '0.95em', color: 'var(--tc-color-gray-700)', marginTop: 4 }}>
                        <span>{it.data_fim == null ? 'Em aberto' : 'Finalizado'}</span>
                        <span>{it.usuario_responsavel_nome && (
                          <> - <i>{it.usuario_responsavel_nome}</i></>
                        )}</span>
                        <span>{it.grupo_responsavel_nome && (
                          <> / <i>{it.grupo_responsavel_nome}</i></>
                        )}</span>
                        {it.data_criacao && <span>, criado em <i>{formatDate(it.data_criacao, 'dd/MM/yyyy HH:mm')}</i></span>}
                      </div>
                    </GridItem>
                    <GridItem sm={12} md={6}>

                      {atividade && (
                        <div style={{ marginTop: 6, fontSize: '0.92em', color: 'var(--tc-color-gray-600)' }}>
                          {atividade.usuario_responsavel_id === user.id && dentroJanela30Min(atividade) && !atividade.data_fim && (
                            <div style={{ color: 'var(--tc-color-warning)', fontSize: '0.85em', marginBottom: 4 }}>
                              {(() => {
                                const dataCriacao = atividade.data_criacao ? new Date(atividade.data_criacao) : new Date(atividade.data_inicio);
                                const agora = new Date();
                                const diffMin = Math.floor(30 - ((agora.getTime() - dataCriacao.getTime()) / (1000 * 60)));
                                return diffMin > 0
                                  ? `Você pode editar esta atividade por mais ${diffMin} minuto${diffMin === 1 ? '' : 's'}`
                                  : 'Janela de edição encerrada';
                              })()}
                            </div>
                          )}
                          {atividade.usuario_responsavel_id === user.id && dentroJanela30Min(atividade) && atividadeEditandoId === atividade.id ? (
                            <>
                              <CampoMemoMencao
                                instanceId={`edit-desc-${atividade.id}`}
                                label="Descrição da atividade"
                                value={atividadeDescricaoEdit}
                                onChange={setAtividadeDescricaoEdit}
                                usuarios={queryUsuarios.data}
                              />
                              <HBox gap="8px" style={{ marginTop: 8 }}>
                                <Botao
                                  variant="primary"
                                  icon={mdiContentSave}
                                  onClick={() => editarAtividadeMutator.mutate({ ticketId: it.id, atividadeId: atividade.id, descricao: atividadeDescricaoEdit })}
                                  disabled={editarAtividadeMutator.isLoading}
                                >
                                  Salvar
                                </Botao>
                                <Botao
                                  variant="secondary"
                                  icon={mdiCancel}
                                  onClick={() => { setAtividadeEditandoId(null); setAtividadeDescricaoEdit(''); }}
                                >
                                  Cancelar
                                </Botao>
                              </HBox>
                            </>
                          ) : (
                            <Editavel
                              enabled={atividade.usuario_responsavel_id === user.id && dentroJanela30Min(atividade) && !atividade.data_fim}
                              value={atividade.descricao}
                              onSave={(v) => editarAtividadeMutator.mutate({ ticketId: it.id, atividadeId: atividade.id, descricao: v })}
                              view={(v) => <span><b>Atividade recente:</b> {v}</span>}
                              editor={({ value, setValue, error, autoFocus }) => (
                                <CampoMemoMencao
                                  instanceId={`edit-desc-${atividade.id}`}
                                  label="Descrição da atividade"
                                  value={value}
                                  onChange={setValue}
                                  usuarios={queryUsuarios.data}
                                  error={error ?? undefined}
                                  autoFocus={autoFocus}
                                />
                              )}
                            />
                          )}
                          <HBox style={{ fontStyle: 'italic', fontSize: '0.85em', marginTop: 4 }} gap={0}>
                            <span>{atividade.data_inicio ? format(atividade.data_inicio, 'dd/MM/yyyy HH:mm') : '-'}</span>
                            {atividade.usuario_responsavel && <span> -{atividade.usuario_responsavel?.nome || ''}</span>}
                            <span>, {atividade.data_fim ? 'Finalizada' : 'Em andamento'}</span>
                          </HBox>
                        </div>
                      )}
                    </GridItem>
                    <GridItem sm={12} md={1}>
                      <HBox gap={0}>
                        <Botao
                          variant="outline-info"
                          icon={mdiOpenInNew}
                          style={{ marginRight: '8px' }}
                          href={`/ticket?id=${it.id}`}
                          target="_blank"
                          title="Visualizar ticket"
                        ></Botao>
                        <Botao
                          variant="outline-primary"
                          icon={mdiPlus}
                          style={{ marginRight: '8px' }}
                          onClick={() => setObjTicketActivity({ ticketId: it.id, descricao: '' })}
                          target="_blank"
                          title="Adicionar atividade"
                        ></Botao>
                        {atividade?.usuario_responsavel_id === user.id && !atividade?.data_fim && (
                          <Botao
                            variant="outline-success"
                            icon={mdiCheckCircle}
                            style={{ marginLeft: 8 }}
                            onClick={async () => {
                              try {
                                await axios.put(`/api/ticket/${it.id}/atividade/${atividade.id}/finalizar`, { data_fim: new Date() }, { withCredentials: true });
                                toast('Atividade finalizada com sucesso', { position: 'top-center', type: 'success' });
                                queryClient.invalidateQueries(['tickets', chat?.cliente?.id]);
                                queryClient.invalidateQueries(['tickets/box', chat?.cliente?.id]);
                              } catch (err: any) {
                                toast(err?.response?.data?.msg || 'Erro ao finalizar atividade', { position: 'top-center', type: 'error' });
                              }
                            }}
                          ></Botao>
                        )}
                      </HBox>
                    </GridItem>
                  </Grid>
                </div>
              );
            })
          )}
          {qTickets.data != null && qTickets.data.length === 0 && (
            <div style={{ textAlign: 'center' }}>Este contato não possui tickets abertos</div>
          )}
          <Botao
            variant="primary"
            onClick={() => setShowNewClientTicket(true)}
          >
            Novo ticket para este contato
          </Botao>
        </VBox>
      </Modal>


      <Modal
        size="md"
        show={objTicketActivity != null}
        onClose={() => setObjTicketActivity(null)}
        onCancel={() => setObjTicketActivity(null)}
        onConfirm={handleSaveTicketActivity}
        title="Atividade no ticket"
      >
        <CampoMemoMencao
          instanceId={`nova-atividade-${objTicketActivity?.ticketId}`}
          label="Nova atividade"
          value={objTicketActivity?.descricao}
          onChange={(v) => setObjTicketActivity((prev: any) => prev ? ({ ...prev, descricao: v }) : prev)}
          usuarios={queryUsuarios.data}
        />
        <AlertBox variant='info' style={{ marginTop: 8 }}>
          <span>A data de início da atividade será registrada como o momento em que você clicar em "Confirmar".</span>
          <span> Dica: Você pode mencionar outros usuários do sistema nesta atividade, digitando <b>@</b> seguido do nome do usuário.</span>
        </AlertBox>
      </Modal>

      <Modal
        size="md"
        show={showNewClientTicket}
        onClose={handleCloseNewTicket}
        onCancel={handleCloseNewTicket}
        onConfirm={handleSaveNewTicket}
        title="Novo ticket para este contato"
      >
        {qNewTicketSuggestion.isFetching
          ? (
            <AlertBox variant='info'>
              <HBox>
                <Icon path={mdiLoading} size={0.7} spin />
                Gerando sugestões. Aguarde!
              </HBox>
            </AlertBox>
          ) : (
            <AlertBox variant='info'>
              <HBox>
                ✨ A IA sugeriu o conteúdo para este ticket, mas fique à vontade para editar os campos antes de salvar.
              </HBox>
            </AlertBox>
          )}
        <Grid>
          <GridItem sm={12}>
            <CampoTexto
              instanceId='titulo'
              value={objNewTicket?.titulo || ''}
              onChange={v => setObjNewTicket({ ...objNewTicket, titulo: v })}
              label="Título"
              placeholder="Título do ticket"
              required
            // error={fieldErrors?.titulo}
            />
          </GridItem>
          <GridItem sm={12}>
            <CampoMemo
              instanceId='descricao'
              value={objNewTicket?.descricao || ''}
              onChange={v => setObjNewTicket({ ...objNewTicket, descricao: v })}
              label="Descrição"
              placeholder="Descreva o problema relatado pelo cliente"
              min={20}
              max={2500}
              rows={5}
            // error={fieldErrors?.descricao}
            />
          </GridItem>
          <GridItem sm={12}>
            <CampoSeletor
              options={[
                { id: 'baixa', label: 'Baixa - Sistema ok, poucos clientes afetados, paliativo conhecido' },
                { id: 'media', label: 'Média - Sistema em instabilidade, múltiplos clientes afetados, sem paliativo conhecido' },
                { id: 'alta', label: 'Alta - Sistema fora do ar, todos os clientes afetados, sem paliativo conhecido' },
              ]}
              value={objNewTicket?.prioridade || 'media'}
              onChange={v => setObjNewTicket({ ...objNewTicket, prioridade: v as TicketPrioridade })}
              label="Prioridade"
              placeholder="Selecione a prioridade do ticket"
              required
            // error={fieldErrors?.prioridade}
            />
          </GridItem>
          <GridItem sm={12}>
            <CampoMemo
              instanceId='atividade_inicial'
              value={objNewTicket?.atividade_inicial || ''}
              onChange={v => setObjNewTicket({ ...objNewTicket, atividade_inicial: v })}
              label="Atividade inicial"
              placeholder="O que será feito neste ticket para solucionar o problema do cliente?"
              min={20}
              max={2500}
              rows={5}
            // error={fieldErrors?.descricao}
            />
          </GridItem>
        </Grid>
      </Modal>

      <Modal
        size="lg"
        show={showTrocarAtendente}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onConfirm={handleConfirmModal}
        title="Trocar atendente"
        confirmProps={{
          disabled: (!atendenteSelecionado && !departamentoSelecionado) || !motivo.trim() || chgAtendenteMutator.isLoading,
        }}
        cancelProps={{
          disabled: chgAtendenteMutator.isLoading,
        }}
      >

        <p>
          Selecione para qual atendente deseja encaminhar este atendimento
        </p>

        <Grid>
          <GridItem sm={12} md={6}>
            <VBox gap="8px">
              <div className={styles.trocarAtendenteBox}>
                <HBox style={{ width: '100%', justifyContent: 'space-between' }}>
                  <VBox style={{ width: 'auto' }} center>
                    <div style={{ color: 'var(--tc-color-primary)' }}>
                      Atendente atual
                    </div>
                    <div>
                      {chat.usuario_responsavel_nome ?? chat.usuario_responsavel_id
                        ? chat.usuario_responsavel_id == user.id
                          ? user.nome + ' (você)'
                          : queryUsuarios?.data?.find(
                            it =>
                              it.id?.toString() == chat.usuario_responsavel_id?.toString(),
                          )?.nome
                        : '(Não identificado)'}
                    </div>
                  </VBox>
                  <Icon
                    path={mdiArrowRight}
                    size={1.5}
                    color="var(--tc-color-primary)"
                  />
                  {departamentoSelecionado && (
                    <VBox style={{ width: 'auto' }} center>
                      <div style={{ color: 'var(--tc-color-primary)' }}>
                        Departamento
                      </div>
                      <div>
                        {queryGrupos.data?.find(it => it.id === +departamentoSelecionado)
                          ?.nome ?? '(Selecione abaixo)'}
                      </div>
                    </VBox>
                  )}
                  {!departamentoSelecionado && (
                    <VBox style={{ width: 'auto' }} center>
                      <div style={{ color: 'var(--tc-color-primary)' }}>
                        Novo atendente
                      </div>
                      <div>
                        {atendenteSelecionado
                          ? atendentes.find(it => it.id === atendenteSelecionado)
                            ?.label
                          : '(Selecione abaixo)'}
                      </div>
                    </VBox>
                  )}
                </HBox>
              </div>

              <div>
                <label style={{ display: 'block', marginTop: '8px', color: 'var(--tc-color-primary)', fontSize: '0.9rem' }}>
                  Motivo da transferência <span style={{ color: 'red' }}>*</span>
                </label>
                <CampoMemo
                  value={motivo}
                  onChange={(v) => setMotivo(v)}
                  max={500}
                  min={10}
                  placeholder="Descreva o motivo da transferência..."
                />
              </div>
            </VBox>
          </GridItem>
          <GridItem sm={12} md={6}>
            <VBox>
              <div
                style={{
                  flex: 1,
                  width: '100%',
                  border: '1px solid var(--tc-color-gray-300)',
                  borderRadius: '8px',
                  padding: '8px',
                }}
              >
                <CampoSeletorOptions
                  value={atendentes}
                  selectedId={atendSelId}
                  selectedGroupId={grupoSelId}
                  onSelect={(value, groupId) => {
                    setAtendenteSelecionado(value);
                    setDepartamentoSelecionado(null);
                    setAtendSelId(value);
                    setGrupoSelId(null);
                    setGrupoDoUsuarioSelId(groupId ?? null);
                  }}
                  onGroupSelect={value => {
                    setAtendenteSelecionado(null);
                    setDepartamentoSelecionado(value);
                    setAtendSelId(null);
                    setGrupoSelId(value);
                    setGrupoDoUsuarioSelId(null);
                  }}
                  search={atendSearch}
                  onChangeSearch={setAtendSearch}
                />
              </div>
            </VBox>
          </GridItem>
        </Grid>
      </Modal>

      <Modal
        show={showAddTag}
        onClose={() => setShowAddTag(false)}
        onCancel={() => setShowAddTag(false)}
        onConfirm={() => {
          addTagMutator.mutateAsync(selectedTagId);
        }}
        title="Adicionar marcador ao cliente"
        confirmProps={{
          disabled: addTagMutator.isLoading,
          label: 'Adicionar',
        }}
        cancelProps={{
          disabled: addTagMutator.isLoading,
        }}
      >
        <CampoSeletor
          options={optionsTags.filter(
            (it: any) => !chat.cliente?.marcadores?.includes(+it.id),
          )}
          value={selectedTagId?.toString()}
          onChange={(value: string | null) => setSelectedTagId(value ? +value : null)}
          placeholder="Selecione um marcador"
        />
      </Modal>
      <div className={styles.headerVoltar}>
        <Botao
          variant="none-primary"
          onClick={() => onGoBack()}
          icon={mdiArrowLeft}
        >
          Voltar
        </Botao>
      </div>
      <div className={styles.header}>
        <div className={styles.column1}>
          <div className={styles.nome}>
            {chat.cliente?.estado != 'bloqueado' && (
              <HBox>
                <IconeCanal
                  tipo={chat.canal?.tipo ?? 'whatsapp'}
                  style={{ width: '24x', height: '24px' }}
                />
                <span
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  className='rr-mask'
                >
                  {chat.cliente?.nome ?? chat.nome}
                </span>
                {chat.cliente?.id != null && chat.cliente.id > 0 && (
                  <Botao
                    variant="none-primary"
                    icon={mdiTagPlus}
                    title="Adicionar marcador ao contato"
                    onClick={() => setShowAddTag(true)}
                  />
                )}

                {qTickets.data != null && (
                  <>
                    <Botao
                      variant="none-primary"
                      icon={mdiFaceAgent}
                      title={`Este contato possui ${qTickets.data.length} ticket(s) aberto(s)`}
                      onClick={() => setShowTickets(true)}
                    />
                    <Badge
                      variant={qTickets.data.length > 0 ? "info" : "secondary"}
                      title={qTickets.data.map((it: any) => `#${it.id} - ${it.titulo}`).join('\n')}
                    >
                      {qTickets.data.length}
                    </Badge>
                  </>
                )}

                {!chat.cliente?.id && (
                  <Botao
                    variant="none-primary"
                    icon={mdiAccountPlus}
                    title="Adicionar contato"
                    onClick={handleOpenModalNewClient}
                  />
                )}
                {(user?.papel === 'GESTOR' || user?.papel === 'ADMIN') && (
                  <Botao
                    variant="none-primary"
                    icon={mdiEyeCircleOutline}
                    title="Supervisionar IA"
                    onClick={() => navigate(`/ia/supervisao?canal_id=${chat.canal?.id}&canal_cliente_id=${encodeURIComponent(chat.canal_cliente_id ?? '')}`)}
                  />
                )}
                <Marcadores ids={chat.cliente?.marcadores ?? []} />
              </HBox>
            )}
            {chat.cliente?.estado === 'bloqueado' && (
              <HBox>
                <IconeCanal
                  tipo={chat.canal?.tipo ?? 'whatsapp'}
                  style={{ width: '24x', height: '24px' }}
                />
                <span
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  className='rr-mask'
                >
                  {chat.cliente?.nome ?? chat.nome}
                </span>
                <Badge variant='danger'>Bloqueado</Badge>
              </HBox>
            )}
          </div>
          <div className={styles.contato}>
            {['whatsapp', 'wa360'].includes(chat.canal?.tipo ?? 'whatsapp') && (
              <TextoTelefone className='rr-mask' formatar value={chat.canal_cliente_id!.toString()} />
            )}
            {!['whatsapp', 'wa360'].includes(
              chat.canal?.tipo ?? 'whatsapp',
            ) && (
                <span>
                  <span className='rr-mask'>{chat.canal_cliente_id?.toString()}</span> - [#{chat.id}]
                </span>
              )}
            {(chat.cliente?.empresa?.nome_fantasia || chat.cliente?.empresa?.razao_social) && (
              <span className="rr-mask" style={{ fontSize: '0.75rem', fontWeight: 'normal', fontStyle: 'italic', color: 'var(--tc-color-gray-600)' }}> - {chat.cliente.empresa.nome_fantasia || chat.cliente.empresa.razao_social}</span>
            )}
          </div>
          <div className={styles.canal}>{chat.canal?.nome}</div>
        </div>
        {chat.cliente?.estado === 'bloqueado' && (
          <div className={styles.column2} data-testid="chat-status">
            <Badge variant='danger'>Bloqueado</Badge>
          </div>
        )}

        {/* {canMakeCall && chat.canal?.tipo === 'whatsapp' && chat.cliente?.estado != 'bloqueado' && (
          <div>
            <Botao variant="outline-primary" icon={mdiPhone} title="Realizar ligação" onClick={() => onMakeCall()} />
          </div>
        )} */}

        {chat.cliente?.estado != 'bloqueado' && (
          <div className={styles.column2} data-testid="chat-status">
            {chat.estado === 'chatbot' && (
              <>
                <div>
                  <Botao
                    variant="outline-primary"
                    icon={mdiHeadset}
                    disabled={changingEstado}
                    onClick={() => onChatEstadoChange('atendimento')}
                  >
                    Atender
                  </Botao>
                </div>
                {/* {chat.canal?.tipo === 'whatsapp' && (
                  <div>
                    <Botao
                      variant="outline-primary"
                      icon={mdiPhone}
                      onClick={() => { /* Botão de ligação * / }}
                    >
                      Ligar
                    </Botao>
                  </div>
                )} */}
                <div
                  style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}
                >
                  {chat.marcadores && chat.marcadores.length > 0 && (
                    <BadgeMarcadores marcadores={chat.marcadores} />
                  )}

                  <Badge variant="info">
                    <Icon path={mdiRobot} size={0.75} />
                    Bot em ação
                  </Badge>
                </div>
              </>
            )}
            {['atendimento', 'nao_respondido'].includes(chat.estado) && (
              <>
                <HBox gap="12px" className={styles.botoesAtendimento}>
                  <Botao
                    variant="none-primary"
                    icon={mdiHeadset}
                    onClick={handleOpenModal}
                  >
                    Trocar atendente
                  </Botao>

                  {!finalizando && (
                    <Botao
                      variant="outline-primary"
                      icon={mdiCheckCircle}
                      disabled={changingEstado}
                      onClick={() => {
                        setFinalizando(true);
                      }}
                    >
                      Finalizar
                    </Botao>
                  )}
                  {finalizando && (
                    <React.Fragment>
                      <Botao
                        variant="success"
                        icon={mdiThumbUp}
                        disabled={changingEstado}
                        onClick={() => {
                          onChatEstadoChange('finalizado', true);
                          setChangingEstado(true);
                          setFinalizando(false);
                        }}
                      >
                        Solucionado
                      </Botao>
                      <Botao
                        variant="secondary"
                        icon={mdiThumbDown}
                        disabled={changingEstado}
                        onClick={() => {
                          onChatEstadoChange('finalizado', false);
                          setChangingEstado(true);
                          setFinalizando(false);
                        }}
                      >
                        Não resolvido
                      </Botao>
                      <Botao
                        variant="none-primary"
                        icon={mdiClose}
                        onClick={() => setFinalizando(false)}
                      ></Botao>
                    </React.Fragment>
                  )}
                </HBox>
                <div
                  style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}
                >
                  {chat.marcadores && chat.marcadores.length > 0 && (
                    <BadgeMarcadores marcadores={chat.marcadores} />
                  )}

                  <Badge variant="warning">
                    <Icon path={mdiHeadset} size={0.75} />
                    {chat.usuario_responsavel_nome}
                  </Badge>
                </div>
              </>
            )}
            {['finalizado'].includes(chat.estado) && (
              <>
                <div>
                  <Botao
                    variant="outline-primary"
                    icon={mdiMessage}
                    disabled={changingEstado}
                    onClick={() => onChatEstadoChange('atendimento')}
                  >
                    Reabrir
                  </Botao>
                </div>
                <div
                  style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}
                >
                  {chat.marcadores && chat.marcadores.length > 0 && (
                    <BadgeMarcadores marcadores={chat.marcadores} />
                  )}

                  <Badge variant="primary">
                    <Icon path={mdiCheckCircle} size={0.75} />
                    Finalizado
                  </Badge>
                </div>
              </>
            )}
            {chat.estado === 'aguardando_cliente' && (
              <VBox center>
                <Icon
                  path={mdiChatProcessing}
                  size={2}
                  color="var(--tc-color-gray-400)"
                />
                <Badge variant="info"> Aguardando cliente... </Badge>
              </VBox>
            )}

            {chat.estado === 'aguardando_atendente' && (
              <VBox center>
                {/* 

              // Isso pode potencialmente favorecer clientes a "roubarem" chats de outros atendentes, ou atravessar a fila de atendimento
              {canAccept ? (
                <Botao
                  variant="primary"
                  icon={mdiHeadset}
                  onClick={onAccept}
                >
                  Atender
                </Botao>
              ) : (
                <Icon
                  path={mdiHeadset}
                  size={2}
                  color="var(--tc-color-gray-400)"
                />
              )} */}
                <Icon
                  path={mdiHeadset}
                  size={2}
                  color="var(--tc-color-gray-400)"
                />
                <Badge variant="info"> Aguardando atendimento... </Badge>
              </VBox>
            )}
          </div>
        )}
      </div>

      <span
        style={{
          visibility: isLoading ? 'visible' : 'hidden',
          position: 'absolute',
          top: '100px',
          marginLeft: 'auto',
          marginRight: 'auto',
          left: 0,
          right: 0,
          textAlign: 'center',
          transform: 'translateX(-50%)',
          width: '2rem',
          height: '2rem',
          backgroundColor: '#fff',
          border: '1px solid #CCC',
          borderRadius: '50%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icon path={mdiLoading} size={1.25} spin={1} />
      </span>

      <div className={styles.body} ref={containerScrollRef}>
        {value?.map((item, index) => {
          const _autorBot = item?.origem === 'bot'
            ? (params?.nome_bot ? params.nome_bot : 'Bot')
            : item?.origem === 'usuario'
              ? chat.cliente?.nome ?? chat.nome
              : undefined;

          return (
            <Mensagem
              item={item}
              index={index}
              mensagens={value}
              key={item.id}
              onSelectedKbSection={onSelectedKbSection}
              autor={_autorBot}
              onBlockContact={onBlockContact}
              onAudioPlaying={onAudioPlaying}
            />
          )
        })}
      </div>
      {chat.estado === 'atendimento' && chat.usuario_responsavel_id != null && chat.usuario_responsavel_id != user.id && (
        <AlertBox variant="info" style={{ margin: '0 24px', alignItems: 'center', fontSize: '1rem', fontWeight: 'bold', borderWidth: 3 }}>
          <div>
            <Icon path={mdiHeadset} size={1} />  Esta conversa está sob responsabilidade de {chat.usuario_responsavel_nome ?? 'outro atendente'}.
          </div>
        </AlertBox>
      )}

      <div className={[styles.footer].join(' ')}>
        {chat.cliente?.estado === 'bloqueado' && (
          <FooterBloqueado />
        )}

        {chat.cliente?.estado != 'bloqueado' && (
          <Footer
            chatId={chat.id}
            rascunhoKey={chatKey(chat)}
            chatTags={chat.marcadores}
            onChatAddTag={onChatAddTag}
            estado={chat.estado}
            onSend={onSend}
            isSending={isSending}
            onSendAudio={onSendAudio}
            onTyping={onTyping}
          />
        )}
      </div>
    </div>
  );
};

export default Mensagens;
